import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class scheduleState extends baseState {
    @observable list = {};
    @action
    setList = data => this.list = data;

    getList = data => {
        return this.fetch({
            url: apiUrl.SCHEDULE.LIST,
            method: 'get',
            setState: "setList",
            data
        });
    }

    @observable detail = {};
    @action
    setDetail = data => this.detail = data;

    getDetail = data => {
        const { id } = data;
        return this.fetch({
            url: joinUrl(apiUrl.SCHEDULE.DETAIL, id),
            method: 'get',
            setState: "setDetail",
            data
        });
    }
}
